import { api } from '../../../../lib/api'

export const UNBLOCK_MERCHANT_REQUEST = 'UNBLOCK_MERCHANT_REQUEST'
export const UNBLOCK_MERCHANT_SUCCESS = 'UNBLOCK_MERCHANT_SUCCESS'
export const UNBLOCK_MERCHANT_FAILED = 'UNBLOCK_MERCHANT_FAILED'

export const unblockMerchant = function (data, onComplete) {
  return function (dispatch) {
    dispatch({
      type: UNBLOCK_MERCHANT_REQUEST
    })
    api.unblockMerchant(data).then(unblockMerchantResponse => {
      dispatch({
        type: UNBLOCK_MERCHANT_SUCCESS,
        payload: unblockMerchantResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: UNBLOCK_MERCHANT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/merchant/unblock-merchant.js